import { all, call, cancelled, fork, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { addLevel, generateTree } from "../../../utils/utils"
import {
  GET_DIMENSIONS_WATCHER,
  GET_DIVISIONS_WATCHER,
  GRAPHIC_BARS_WATCHER,
  GET_HISTORY_BY_DIVISION_WATCHER,
  GET_AMBASSADORS_WATCHER,
  GET_MEASURE_COLOR_RANGE_WATCHER,
} from "./constants"

import {
  getDimensionsSuccess,
  getDivisionsSuccess,
  getHistoryByDivisionSuccess,
  graphicBarsFailed,
  graphicBarsSuccess,
  getAmbassadorsSuccess,
  getOnlyDimensionsSuccess,
  getDimensionsMeasureColorRangeSuccess,
  getQuestionsSuccess,
} from "./actions"
import { LOCAL_TOKEN } from "../../../utils/storage"

/* Graphic bars */
function graphicBarsApi({ idMeasure, data, params, idSegment, isExclude }) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/historical/comparative/chart`,
    data,
    params: { ...params, id_segment: idSegment, exclude: isExclude || false },
  })
}

export function* graphicBarsSaga(params) {
  try {
    const { data } = yield call(graphicBarsApi, params.payload)
    yield put(graphicBarsSuccess(data))
  } catch (error) {
    yield put(graphicBarsFailed())
    returnMessage(error)
  }
}

function getReportMeasureInfoApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.idMeasure}/info`,
    params: { id_segment: params.idSegment },
  })
}

function getReportMeasureTotalApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.idMeasure}/total`,
    params: { id_segment: params.idSegment },
  })
}

function getDimensionsApi(payload) {
  let url = `reports/measure/${payload.idMeasure}/dimensions`
  let params = {
    exclude: payload.isExclude || false,
    id_segment: payload.idSegment,
  }
  if (payload.idDivision && payload.idDivision !== "all") {
    url = `reports/measure/${payload.idMeasure}/divisions/${payload.idDivision}/dimensions`
    params = {
      exclude: payload.isExclude || false,
      id_segment: payload.idSegment,
    }
  }
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params,
  })
}

function getQuestionsApi(payload) {
  let url = `reports/measure/${payload.idMeasure}/questions`
  let params = {
    id_segment: payload.idSegment,
  }
  if (payload.idDivision && payload.idDivision !== "all") {
    url = `reports/measure/${payload.idMeasure}/divisions/${payload.idDivision}/questions`
    params = {
      exclude: payload.isExclude,
      id_segment: payload.idSegment,
    }
  }
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params,
  })
}

function getDivisionsApi(payload) {
  const url = `reports/measure/${payload.idMeasure}/divisions`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: {
      exclude: payload.isExclude,
      id_segment: payload.params.id_segment,
      id_division: payload.id_division,
    },
  })
}

function getDivisionsAvailableApi(payload) {
  const url = `reports/measure/${payload.idMeasure}/divisions`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: {
      id_division: payload.divisionToUseAmbassador,
      exclude: payload.isExclude,
      id_segment: payload.idSegment,
    },
  })
}

function getMeasureColorRangeApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.payload.measure}/color-range`,
  })
}

function getEvolutionHistoryByDivision(payload) {
  const url = `reports/measure/${payload.idMeasure}/evolution`
  if (payload.idDivision === "all") {
    payload.idDivision = null
  }
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: {
      id_division: payload.idDivision,
      id_segment: payload.idSegment,
      exclude: payload.isExclude || false,
    },
  })
}

export function* getDivisionsSaga(params) {
  try {
    const { data: divisionsApi } = yield call(getDivisionsApi, params.payload)
    yield put(
      getDivisionsSuccess({
        data: divisionsApi.data,
        total: divisionsApi.metric_total,
      })
    )
  } catch (e) {}
}

export function* getHistoryByDivision(action) {
  try {
    const { data: evolutionData } = yield call(
      getEvolutionHistoryByDivision,
      action.payload
    )
    yield put(getHistoryByDivisionSuccess(evolutionData))
  } catch (error) {
    returnMessage(error)
  }
}

export function* getDimensionsSaga(action) {
  try {
    const [
      { data: dimensionsApi },
      { data: questionsApi },
      { data: measureInfo },
      { data: measureTotal },
    ] = yield all([
      call(getDimensionsApi, action.payload),
      call(getQuestionsApi, action.payload),
      call(getReportMeasureInfoApi, action.payload),
      call(getReportMeasureTotalApi, action.payload),
    ])
    const dimensions = dimensionsApi.data
    const questions = questionsApi.data
    questions.map((e) => {
      return (e.id = parseInt(
        e.id_dimension + Math.floor(Math.random() * 1000000 + 1)
      ))
    })

    if (action.payload.idDivisionParent)
      action.payload.divisionToUseAmbassador = action.payload.idDivisionParent
    else
      action.payload.divisionToUseAmbassador =
        measureTotal.user_type.divisions && measureTotal.user_type.divisions[0]
          ? measureTotal.user_type.divisions[0].id_division
          : null

    const result = {
      metricTotal: action.payload.isEngagement
        ? dimensionsApi.measure_engagement
        : dimensionsApi.metric_total,
      outcomes: dimensionsApi.dimensions_outcomes,
      showHistory: dimensionsApi.show_history,
      ifFirst: dimensionsApi.is_first,
      switchMoreDimensions: dimensionsApi.switch,
      showDimensionBenchmark: dimensionsApi.show_dimension_benchmark,
      employeesTotal: dimensionsApi.metric_total.employees,
      measureInfo: measureInfo.data,
      ambassadorBenchmarkVisible: measureInfo.data.ambassador_benchmark_visible,
    }

    result.dimensions = generateTree("id", "id_parent", [
      ...JSON.parse(JSON.stringify(dimensions)),
      ...JSON.parse(JSON.stringify(questions)),
    ])
    result.dimensions.forEach(addLevel(1))
    yield put(getQuestionsSuccess(questions))
    if (action.payload.onlyDimension) {
      yield put(getOnlyDimensionsSuccess(result))
    } else {
      yield put(getDimensionsSuccess(result))
    }
  } catch (e) {
    const result = e
    console.log(
      "🚀 ~ file: saga.js ~ line 216 ~ function*getDimensionsSaga ~ result",
      result
    )
  }
}

export function* getAmbassadorsSaga(action) {
  try {
    const {
      data: {
        data: { result },
      },
    } = yield call(fetchGlobalApi, {
      endpoint: `ambassador/ambassadors`,
      params: {
        searchByIdDivisionAmbassadors: action.payload.idDivision,
        exclude: action.payload.isExclude || false,
      },
    })
    yield put(getAmbassadorsSuccess(result))
  } catch (e) {
    console.log(
      "🚀 ~ file: saga.js ~ line 245 ~ function*getAmbassadorsSaga ~ e",
      e
    )
  }
}

export function* getMeasureColorRangeSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const response = yield call(getMeasureColorRangeApi, params)

    yield put(getDimensionsMeasureColorRangeSuccess(response.data.data))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Individual exports for testing
export default function* dimensionByDivisionSaga() {
  yield takeLatest(GET_DIVISIONS_WATCHER, getDivisionsSaga)
  yield takeLatest(GET_DIMENSIONS_WATCHER, getDimensionsSaga)
  yield takeLatest(GRAPHIC_BARS_WATCHER, graphicBarsSaga)
  yield takeLatest(GET_HISTORY_BY_DIVISION_WATCHER, getHistoryByDivision)
  yield takeLatest(GET_AMBASSADORS_WATCHER, getAmbassadorsSaga)
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  // See example in containers/HomePage/saga.js
}
